export type OpenPublishSettingsOptions = {
  /** 批量发布场景：禁用「无需预设」，点击「完成」后触发 onDone */
  batchPublishMode?: boolean;
  onDone?: () => void;
};

type OpenHandler = (options?: OpenPublishSettingsOptions) => void;
type CloseHandler = () => void;

const openHandlers = new Set<OpenHandler>();
const closeHandlers = new Set<CloseHandler>();

/** 打开顶栏「发布视频预设」弹窗（由 Navbar 订阅） */
export function emitOpenPublishSettings(options?: OpenPublishSettingsOptions) {
  openHandlers.forEach((handler) => {
    try {
      handler(options);
    } catch (e) {
      console.warn("[publish-settings] open handler error", e);
    }
  });
}

export function onOpenPublishSettings(handler: OpenHandler) {
  openHandlers.add(handler);
  return () => {
    openHandlers.delete(handler);
  };
}

/** 关闭「发布视频预设」弹窗（如跳转帮助中心前） */
export function emitClosePublishSettings() {
  closeHandlers.forEach((handler) => {
    try {
      handler();
    } catch (e) {
      console.warn("[publish-settings] close handler error", e);
    }
  });
}

export function onClosePublishSettings(handler: CloseHandler) {
  closeHandlers.add(handler);
  return () => {
    closeHandlers.delete(handler);
  };
}
